import { render, staticRenderFns } from "./FloatingPopup.vue?vue&type=template&id=471e0510&"
import script from "./FloatingPopup.vue?vue&type=script&lang=ts&"
export * from "./FloatingPopup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports